import { useQuery } from 'react-query'
import { UseQueryOptions } from 'react-query/types/react/types'
import { ReferenceImage } from 'types'
import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { scheduleKeys } from 'hooks/queries/schedules/scheduleKeys'

interface Data {
  reference_image: ReferenceImage
}

export type Options = Omit<UseQueryOptions<ReferenceImage>, 'queryKey' | 'queryFn'>

export interface Props {
  scheduleId: number
  contentId: number
}

export const fetchReferenceImage = async (scheduleId: number, contentId: number) => {
  const response = await sendToApi<Data>(`/schedules/${scheduleId}/contents/${contentId}/reference_image`)

  if (response.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(response.data)
  }

  return response.data.reference_image
}

export const useReferenceImage = ({ scheduleId, contentId }: Props, options?: Options) => {
  return useQuery<ReferenceImage>(
    scheduleKeys.referenceImage(scheduleId, contentId),
    () => fetchReferenceImage(scheduleId, contentId),
    {
      refetchOnWindowFocus: false,
      ...options,
    },
  )
}

const POLLING_STATUSES = ['pending', 'processing']

export const useReferenceImageSync = (props: Props, options?: Options) => {
  return useReferenceImage(props, {
    refetchInterval: (data) => {
      if (!data || POLLING_STATUSES.includes(data.status as string)) return 500
      return false
    },
    ...options,
  })
}
